import { render, staticRenderFns } from "./RolesPorDefecto.vue?vue&type=template&id=22e9cfd6&scoped=true"
import script from "./RolesPorDefecto.vue?vue&type=script&lang=js"
export * from "./RolesPorDefecto.vue?vue&type=script&lang=js"
import style0 from "./RolesPorDefecto.vue?vue&type=style&index=0&id=22e9cfd6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e9cfd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22e9cfd6')) {
      api.createRecord('22e9cfd6', component.options)
    } else {
      api.reload('22e9cfd6', component.options)
    }
    module.hot.accept("./RolesPorDefecto.vue?vue&type=template&id=22e9cfd6&scoped=true", function () {
      api.rerender('22e9cfd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/usuario/RolesPorDefecto.vue"
export default component.exports